import Logo from '../assets/pw_logo.svg'

export default ({ className, id }) => {
  return (
    <a id={id} href='/' className={className}>
      <img height='100%' src={Logo} alt='PurpleWave Logo' />
    </a>
  )
}
